import { Http } from '@app/base';
import { ChatifyClient } from '@webinex/chatify';
import { CustomChat } from './chatifyCustomTypes';

export class CustomChatifyClient extends ChatifyClient {
  public chats = async () => {
    const { data } = await Http.get<CustomChat[]>('/api/chatify/custom/chats');
    return data;
  };
}
